import { Statusable } from "models/BO/BoUser";
import { Batch } from "./Batch";
import { PreValidation } from "./PreValidation";
import { Question } from "./Question";
import { Action } from "models/content/Comm";


export enum BatchContentType {
    Message = 1,
    Question = 2,
    Other = 3,
    QuestionnaireHeader = 4,
}


export enum BatchContentState {
    Draft = 1,
    Active = 2,
    Deactivated = 3
}

export enum BatchUIMobile { 
    Message = "msgBasic1",
    Button = "chatButton",
    Images = "imageUploader"
}

export type BatchVisSettings = {
    ui_mobile: BatchUIMobile;
}


export type PostConditionAction = PreValidation & {
  action: Action;
}


export class BatchContent implements Statusable {
    id: number;

    
    batchId: number;

    
    questionId: number;

    
    ordinal: number;

    
    contentTypeId: BatchContentType;

    
    skipAllowed: boolean | null;

    
    defaultResponse: string | null;

    
    contentTxtId: string | null;

    
    parentQuestionId: number | null;

    
    preValidation: PreValidation[] | null;

    
    visSettings: BatchVisSettings | null;

    
    layoutId: number | null;

    
    weight: number | null;

    version: number | null;

    
    created: Date;

    
    createdBy: number;

    
    updated: Date;

    
    updatedBy: number;

    
    contentStateId: BatchContentState;

    question:Question;

    batch: Batch;

    text: string | null;

    postConditionAction: PostConditionAction[];


  get status(): number {
    return this.contentStateId;
  }

  set status(value: number) {
        this.contentStateId = value;
  }


  get statuses(): { key: string; value: string }[] {
    return Object.entries(BatchContentState)
    .filter(([key, value]) => !isNaN(Number(key)))
    .map(([key, value]) => ({
      key,
      value: value.toString(),
    }));
  }

  get statusLabel(): string {
    return BatchContentState[this.contentStateId];
  }

  get statusColor(): string {
    switch (+this.contentStateId) {
      case BatchContentState.Draft:
        return "secondary";
      case BatchContentState.Active:
        return "success";
      case BatchContentState.Deactivated:
        return "secondary";
      default:
        return "";
    }
  }
}